module.exports = __webpack_public_path__ + "static/media/icon-shower.3861677f.svg";